import { DataSourceRequestType } from "types/datalist-types";
import { DropdownInputPropsType } from "types/form-types";
import { SeasonFilterInput, SeasonListInfoQueryVariables, SeasonSortInput, SortEnumType } from "types/graphql";
import { seasonListInfo, SeasonType } from "types/season-type";
import * as lodash from 'lodash';
import DropdownInput from "components/common/form/inputs/dropdown/DropdownInput";
import { useTranslation } from "react-i18next";
import { appendFilters, resolveSearchFilterPropertyName } from "utilities/datalist/datalist-filter-utilities";

export const SEASON_ACTIVE_FILTER_ID = -1;

type SeasonDropdownPropsType = DropdownInputPropsType<SeasonType, SeasonFilterInput, SeasonSortInput> & {
    addActive?: boolean
    search?: 'on' | 'switch' | 'off'
}

const SeasonDropdown = (props: Partial<SeasonDropdownPropsType>) => {
    const [t] = useTranslation();

    const defaultConfig: SeasonDropdownPropsType = {
        getItemId: i => i.id,
        view: {
            inputView(i?) {
                if (!i) return '';
                return `${i.name} ${i.active ? '*' : ''}`.trim();
            },
        },
        label: 'fields.season.name',
        name: 'season',
        dataSource: {
            request: async (params: DataSourceRequestType<SeasonFilterInput, SeasonSortInput>) => {
                let variables: SeasonListInfoQueryVariables = {
                    take: params.take,
                    order: params.sort || [{ name: SortEnumType.Desc }],
                    where: params.filters,
                    skip: params.skip
                };

                if (params.searchText) {
                    const nameFilter = resolveSearchFilterPropertyName([], params.searchText);
                    variables.where = appendFilters(variables.where, nameFilter);
                }

                const response = await seasonListInfo(variables);
                if (response.response.success) {
                    return props.addActive ? [{
                        id: SEASON_ACTIVE_FILTER_ID,
                        name: '- ' + t('common.active'),
                        active: false
                    }, ...response.data.items] : response.data.items;
                } else {
                    throw response.response.errors
                }
            },
            search: props.search,
        }
    }

    const settings = lodash.merge(defaultConfig, props);
    return (
        <DropdownInput
            {...settings}
            value={props.value}
        />
    );
};

export default SeasonDropdown;
